import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IIssueReport extends IEntity {
  attributes: {
    id: EntityStringId;
    locationId: string | null;
    locationType: string | null;
    message: string | null;
  };
}

export type IssueReport = Entity<IIssueReport>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IssueReport: IEntityType<IIssueReport> = vmClient.defineClass({
  typeName: 'IssueReport',
  version: 2,
  persisted: true,
  attributes: {
    locationId: 'string',
    locationType: 'string',
    message: 'string',
  },
});
